module.exports = __webpack_public_path__ + "img/zhuansu2.gif";